export const getLatestAge = (dob) => {

    let months;
    let d2 = new Date()
    months = (d2.getFullYear() - dob.split('-')[0]) * 12
    months -= dob.split('-')[1];
    months += d2.getMonth() + 1;
    let res = months <= 0 ? 0 : months;
    return Math.round((res / 12) * 10) / 10
}